/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Clearance } from '../models/Clearance';
import type { PaginatedClearanceList } from '../models/PaginatedClearanceList';
import type { PatchedClearanceNotCleared } from '../models/PatchedClearanceNotCleared';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ClearanceService {

    /**
     * @returns PaginatedClearanceList
     * @throws ApiError
     */
    public static clearanceList({
        healthcareEntity,
        limit,
        offset,
        ordering,
        provider,
        search,
    }: {
        healthcareEntity?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: Array<string>,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedClearanceList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/clearance/',
            query: {
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'search': search,
            },
        });
    }

    /**
     * @returns Clearance
     * @throws ApiError
     */
    public static clearanceRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this Name Clearance.
         */
        id: string,
    }): CancelablePromise<Clearance> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/clearance/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns Clearance
     * @throws ApiError
     */
    public static clearanceClearedPartialUpdate({
        id,
    }: {
        /**
         * A UUID string identifying this Name Clearance.
         */
        id: string,
    }): CancelablePromise<Clearance> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/clearance/{id}/cleared/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns Clearance
     * @throws ApiError
     */
    public static clearanceNotClearedPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Name Clearance.
         */
        id: string,
        requestBody?: PatchedClearanceNotCleared,
    }): CancelablePromise<Clearance> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/clearance/{id}/not-cleared/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns Clearance
     * @throws ApiError
     */
    public static clearancePendingPartialUpdate({
        id,
    }: {
        /**
         * A UUID string identifying this Name Clearance.
         */
        id: string,
    }): CancelablePromise<Clearance> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/clearance/{id}/pending/',
            path: {
                'id': id,
            },
        });
    }

}
